import React, { PropsWithChildren, useEffect, useRef, useState } from "react";
import cn from "classnames";
import { twMerge } from "tailwind-merge";

type Props = {
  content: React.ReactNode;
  className?: string;
  trigger?: "click" | "hover";
  direction?: "top" | "bottom" | "left" | "right";
};

export const ReactPopover: React.FC<PropsWithChildren<Props>> = ({
  children,
  content,
  className,
  trigger = "click",
  direction = "top",
}: any) => {
  const [show, setShow] = useState(false);
  const wrapperRef = useRef<any>(null);

  const handleMouseOver = () => {
    if (trigger === "hover") {
      setShow(true);
    }
  };

  const handleMouseLeft = () => {
    if (trigger === "hover") {
      setShow(false);
    }
  };

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShow(false);
      }
    }

    if (show) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [show, wrapperRef]);

  return (
    <div
      ref={wrapperRef}
      onMouseEnter={handleMouseOver}
      onMouseLeave={handleMouseLeft}
      className={cn(
        twMerge("w-fit h-fit relative flex justify-center", className),
      )}
    >
      <div onClick={() => setShow(!show)}>{children}</div>
      <div
        hidden={!show}
        className={cn(
          "min-w-fit w-[200px] h-fit absolute z-50 transition-all",
          {
            "bottom-[100%]": direction === "top",
            "top-[150%]": direction === "bottom",
            "bottom-[0%] left-[110%]": direction === "right",
          },
        )}
      >
        <div className="rounded border bg-white p-3 shadow-[10px_30px_150px_rgba(46,38,92,0.25)] mb-[10px]">
          {content}
        </div>
      </div>
    </div>
  );
};
